"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _reactDom = require("react-dom"),
    _classnames = _interopRequireDefault(require("classnames")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _reactSizeme = require("react-sizeme"),
    _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _Filters = _interopRequireDefault(require("./Filters")),
    _Placeholder = _interopRequireDefault(require("./Placeholder")),
    _BulkActions = _interopRequireDefault(require("../../BulkActions")),
    _CardItem = _interopRequireDefault(require("./Card/components/CardItem")),
    _ListItem = _interopRequireDefault(require("./ListItem")),
    _Checkbox = _interopRequireDefault(require("../../Checkbox")),
    _viewTypes = require("../constants/viewTypes"),
    _list = require("../styles/list"),
    _vars = require("../../../common/styles/vars");

require("../styles/_list.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var NO_INFINITE_LOAD_ITEMS = 3,
    GRID_NODE_SELECTOR = ".list-container__content__item > *",
    List = function (a) {
  function b(a) {
    var d;
    (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.handleChangeView = (0, _lodash["default"])(function (a) {
      return function () {
        var b = d.props.history;
        b.push("#".concat(a)), a === _viewTypes.GRID_VIEW && d.setGridNodes();
      };
    }), d.getFilteredData = (0, _memoizeOne["default"])(function (a, b, c, d) {
      if (d) return a;
      var e = a.filter(function (a) {
        return Object.values(a).some(function (a) {
          return a && "string" == typeof a && a.toLowerCase().includes(c.toLowerCase());
        });
      });
      return e.filter(function (a) {
        var c = Object.values(b),
            d = c.map(function (b) {
          var c = b.value;
          return !(c instanceof Function) || c(a);
        });
        return d.filter(function (a) {
          return a;
        }).length === d.length;
      });
    }), d.hideSelectedItems = function () {
      var a = d.props,
          b = a.data,
          c = a.listKey,
          e = a.bulkActions,
          f = a.onFiltersChange,
          g = d.state,
          h = g.selectedFilters,
          i = g.searchTerm,
          j = d.getFilteredData(b, h, i, f);

      if (e) {
        var k = d.state.selectedItems,
            l = Object.entries(k).reduce(function (a, b) {
          var d = (0, _slicedToArray2["default"])(b, 2),
              e = d[0],
              f = d[1];
          if (!f) return a;
          var g = j.some(function (a) {
            return a[c] === e;
          });
          return g ? _objectSpread({}, a, (0, _defineProperty2["default"])({}, e, !0)) : a;
        }, {});
        d.setState({
          selectedItems: l
        });
      }
    }, d.onSelectItem = function (a) {
      return function () {
        var b = d.state.selectedItems,
            c = d.props,
            e = c.listKey,
            f = c.data,
            g = Object.values(b).filter(Boolean).length;
        if (void 0 === a && (!g || g !== f.length)) return void d.setState({
          selectedItems: f.reduce(function (a, b) {
            return _objectSpread({}, a, (0, _defineProperty2["default"])({}, b[e], !0));
          }, {})
        });
        if (void 0 === a) return void d.setState({
          selectedItems: {}
        });
        var h = f[a],
            i = h[e];
        d.setState(function (a) {
          var b = a.selectedItems;
          return {
            selectedItems: _objectSpread({}, b, (0, _defineProperty2["default"])({}, i, !b[i]))
          };
        });
      };
    }, d.onSelectBulkAction = function (a) {
      return function () {
        var b = d.state.selectedItems,
            c = d.props,
            e = c.data,
            f = c.listKey;
        a(e.filter(function (a) {
          return b[a[f]];
        }));
      };
    }, d.setSelectedFilters = function (a) {
      d.setState(function (b) {
        var c = b.selectedFilters;
        return {
          selectedFilters: _objectSpread({}, c, {}, a)
        };
      }, d.callOnFiltersChangeCallback);
    }, d.callOnFiltersChangeCallback = function () {
      var a = d.props.onFiltersChange,
          b = d.state.searchTerm;
      a && a({
        filters: d.getSelectedFiltersData(),
        searchTerm: b
      });
    }, d.getSelectedFiltersData = function () {
      var a = d.state.selectedFilters;
      return Object.keys(a).reduce(function (b, c) {
        return _objectSpread({}, b, (0, _defineProperty2["default"])({}, c, a[c].value));
      }, {});
    }, d.resetFilters = function () {
      d.setState({
        selectedFilters: {}
      }, d.callOnFiltersChangeCallback);
    }, d.onSearch = function (a) {
      var b = a.target.value;
      d.setState({
        searchTerm: b
      }, d.callOnFiltersChangeCallback);
    }, d.getView = function (a) {
      var b = d.props,
          c = b.renderCardItem,
          e = b.renderListItem,
          f = a ? a.substr(1, a.length) : _viewTypes.GRID_VIEW;
      return f !== _viewTypes.GRID_VIEW || c ? f !== _viewTypes.LIST_VIEW || e ? f : _viewTypes.GRID_VIEW : _viewTypes.LIST_VIEW;
    }, d.getSearchResult = function (a) {
      var b = d.props.totalResults;
      return _react["default"].createElement("div", {
        className: _list.SEARCH_RESULT
      }, _react["default"].createElement(_Icon["default"], {
        color: "michael",
        name: "user",
        size: 30
      }), _react["default"].createElement("h4", null, "Search Results (".concat(b || a.length, ")")));
    }, d.getNumLoadingItems = function (a, b, c) {
      var d = c.fixed,
          e = a.width,
          f = void 0 === e ? 500 : e,
          g = a.height,
          h = void 0 === g ? 500 : g,
          i = d ? NO_INFINITE_LOAD_ITEMS : (h - 130) / 135,
          j = b === _viewTypes.GRID_VIEW ? (f - 40) / 213 : i;
      return parseInt(j, 10);
    }, d.renderPlaceholder = function (a, b, c) {
      var e = c.fixed,
          f = d.props.bulkActions,
          g = d.getNumLoadingItems(b, a, {
        fixed: e
      }),
          h = (0, _toConsumableArray2["default"])(Array(g));
      return h.map(function (b, c) {
        return _react["default"].createElement(_Placeholder["default"], {
          key: c,
          view: a,
          hasBulkActions: !!f
        });
      });
    }, d.loadMoreResults = function () {
      var a = d.props,
          b = a.data,
          c = a.loadMoreResults,
          e = a.totalResults;
      return c ? c({
        currentOffset: b.length,
        totalResults: e
      }) : Promise.resolve();
    }, d.renderItemCheckbox = function (a) {
      var b = a.view,
          c = a.listItem,
          e = a.index,
          f = d.props,
          g = f.listKey,
          h = f.bulkActions,
          i = d.state,
          j = i.gridNodes,
          k = i.selectedItems,
          l = i.hasBulkActions;
      if (!h || !h.length) return null;
      var m = c.permissions,
          n = h.filter(function (a) {
        var b = a.requiredPermission;
        return !b || !!(m && m.includes(b));
      });
      return n.length ? (l || d.setState({
        hasBulkActions: !0
      }), b === _viewTypes.LIST_VIEW ? _react["default"].createElement(_Checkbox["default"], {
        onChange: d.onSelectItem(e),
        checked: !!k[c[g]]
      }) : j[e] ? (0, _reactDom.createPortal)(_react["default"].createElement(_Checkbox["default"], {
        onChange: d.onSelectItem(e),
        checked: !!k[c[g]]
      }), j[e]) : null) : null;
    };
    var e = !!(a.renderCardItem && a.renderListItem);
    return d.state = {
      selectedFilters: {},
      searchTerm: "",
      bothViewsAvailable: e,
      selectedItems: {},
      gridNodes: [],
      hasBulkActions: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setGridNodes();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(a, b) {
      var c = this.props.data,
          d = this.state,
          e = d.searchTerm,
          f = d.selectedFilters;
      (a.data !== c || b.searchTerm !== e || b.selectedFilters !== f) && (this.setGridNodes(), this.hideSelectedItems());
    }
  }, {
    key: "setGridNodes",
    value: function setGridNodes() {
      var a = this,
          b = this.props,
          c = b.location,
          d = b.bulkActions;
      d && !this.getView(c.hash) !== _viewTypes.GRID_VIEW && setTimeout(function () {
        a.setState({
          gridNodes: (0, _toConsumableArray2["default"])(document.querySelectorAll(GRID_NODE_SELECTOR))
        });
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var a = this,
          b = this.state,
          c = b.searchTerm,
          d = b.bothViewsAvailable,
          e = b.selectedFilters,
          f = b.selectedItems,
          g = b.hasBulkActions,
          h = this.props,
          i = h.bulkActions,
          j = h.location,
          k = h.loading,
          l = h.filters,
          m = h.renderCardItem,
          n = h.renderListItem,
          o = h.emptyDataText,
          p = h.listKey,
          q = h.children,
          r = h.filtersRightAddon,
          s = h.totalResults,
          t = h.data,
          u = h.getInfiniteScrollParent,
          v = h.onFiltersChange,
          w = h.hideFilters,
          x = h.maxDisplayNum,
          y = void 0 === x ? 0 : x,
          z = this.getFilteredData(t, e, c, v),
          A = this.getView(j.hash),
          B = A === _viewTypes.LIST_VIEW ? n : m,
          C = t.filter(function (a) {
        return f[a[p]];
      });
      return _react["default"].createElement(_reactSizeme.SizeMe, {
        monitorHeight: !0
      }, function (b) {
        var h = Number.POSITIVE_INFINITY,
            j = b.size,
            m = j.width < _vars.NUMERIC_MEDIA_SIZES.small;
        return _react["default"].createElement("div", {
          className: (0, _classnames["default"])("list-container", (0, _list.LIST_CONTAINER)({
            loading: k,
            isMobile: m
          }))
        }, !w && _react["default"].createElement(_Filters["default"], {
          isMobile: m,
          view: A,
          filters: l,
          onChangeView: a.handleChangeView,
          setSelectedFilters: a.setSelectedFilters,
          resetFilters: a.resetFilters,
          selectedFilters: e,
          onSearch: a.onSearch,
          bothViewsAvailable: d,
          filtersRightAddon: r
        }), g ? _react["default"].createElement(_BulkActions["default"], {
          actions: i,
          onSelectAction: a.onSelectBulkAction,
          onSelectAll: a.onSelectItem(),
          totalItems: t.length,
          selectedItems: Object.values(f).filter(Boolean).length,
          selectedItemsData: C
        }) : null, c && a.getSearchResult(z), y && z.length > y ? _react["default"].createElement("div", {
          className: "list__result-limit"
        }, _react["default"].createElement(_Icon["default"], {
          color: "michael",
          name: "alert",
          size: 25
        }), _react["default"].createElement("p", null, "Too many results to display. Use the filters to find the items you need.")) : null, _react["default"].createElement(_reactInfiniteScroller["default"], {
          pageStart: 0,
          loadMore: a.loadMoreResults,
          hasMore: !k && t && t.length < (s || 0),
          getScrollParent: u,
          useWindow: !u,
          loader: _react["default"].createElement("div", {
            key: "infinite-scroll-loader",
            className: (0, _classnames["default"])("list-container__content", "list-container__infinite-load", (0, _defineProperty2["default"])({
              "list-container__infinite-load--grid": A === _viewTypes.GRID_VIEW
            }, (0, _list.CARDS_GRID)({
              isMobile: m
            }), A === _viewTypes.GRID_VIEW))
          }, a.renderPlaceholder(A, j, {
            fixed: !0
          }))
        }, _react["default"].createElement("div", {
          className: (0, _classnames["default"])("list-container__content", (0, _defineProperty2["default"])({
            "list-container__content--grid": A === _viewTypes.GRID_VIEW
          }, (0, _list.CARDS_GRID)({
            isMobile: m
          }), A === _viewTypes.GRID_VIEW))
        }, k ? a.renderPlaceholder(A, j, {
          fixed: !0
        }) : z.slice(0, y || h).map(function (b, c) {
          return _react["default"].createElement("div", {
            className: (0, _classnames["default"])("list-container__content__item", {
              "list-container__content__item--selected": f[b[p]]
            }),
            key: b[p]
          }, a.renderItemCheckbox({
            view: A,
            listItem: b,
            index: c
          }), B && B(b, c));
        }))), q, 0 !== t.length || k ? null : _react["default"].createElement("div", {
          className: (0, _classnames["default"])(_list.EMPTY_DATA, "list__empty-data-container")
        }, o || "No results found."));
      });
    }
  }]), b;
}(_react.Component);

exports["default"] = List, List.defaultProps = {
  data: [],
  filters: {},
  listKey: "id"
}, List.ListItem = _ListItem["default"], List.CardItem = _CardItem["default"];